'use strict';

export const STUDY_BUILDER_DRAFT_TOKEN_KEY = 'studyBuilderDraftToken';

export function writeStudyBuilderDraftToken(token) {
	if (!token) return;
	try {
		localStorage.setItem(STUDY_BUILDER_DRAFT_TOKEN_KEY, String(token));
	} catch {
		// ignore quota / private mode
	}
}

/** Read and remove the draft token so it is not reused on unrelated logins. */
export function consumeStudyBuilderDraftToken() {
	try {
		const token = localStorage.getItem(STUDY_BUILDER_DRAFT_TOKEN_KEY);
		if (token) {
			localStorage.removeItem(STUDY_BUILDER_DRAFT_TOKEN_KEY);
			return token;
		}
	} catch {
		// ignore
	}
	return null;
}
